import axios from 'axios';
import {URL_MAPA} from '../config/urls';

export default class MapaServices {
	getAgencias () {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/agencias`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getTiposDeContrato () {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/tipos_de_contrato`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getKits (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/orcamentos/kit?orcamento=${id}`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});			
	}

	getItemKitById (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/orcamentos/kit/item/${id}`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});			
	}

	getOrcamento (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/orcamento/${id}`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});	
	}

	getCliente (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/clientes/${id}`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getNomeRepresentante (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/representantes/${id}/nome`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getNomeAgencia (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/agencias/${id}/nome`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getDiagramadores () {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/diagramadores`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});	
	}

	getAtendentes () {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/atendentes`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});	
	}

	getTabela (idOrcamento) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/orcamento/${idOrcamento}/tabela`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});	
	}

	atualizarContratoCronograma (id, data) {
		return new Promise((resolve,reject)=>{
			axios.put(`${URL_MAPA}/contratos/${id}`, data, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getContatos (idCliente) {
		return new Promise((resolve, reject) => {
			axios.get(`${URL_MAPA}/cliente/${idCliente}/all`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	getContatosByOrcamento (orcamento) {
		return new Promise((resolve, reject) => {
			axios.get(`${URL_MAPA}/pegar-clientes-pelo-orcamento/${orcamento}`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	atualizarContato (contato) {
		return new Promise((resolve, reject) => {
			axios.put(`${URL_MAPA}/cliente/contato/${contato.idContato}`, contato, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	findContratosBy (campos) {
		return new Promise((resolve, reject) => {
			axios.post(`${URL_MAPA}/findOrcaments`, campos, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response) => {
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});
	}

	alterarContatosMetricsAPI (data) {
		return new Promise((resolve,reject) => {
			axios.post(`${URL_MAPA}/alterar-contatos-metrics`, {numContrato: data.numero, contatos: data.contatos}, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getOrcamentoComKits (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/orcamento-com-kit/${id}`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});	
	}

	possuiAlphaPlay (id) {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/orcamento/${id}/alpha-play`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}
	
	cadastrarNomesArquivosFechamento (numero) {
		return new Promise((resolve, reject) => {
			axios.post(`${URL_MAPA}/fechar-arquivo/criar-nome`, {contrato: numero}, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	consultarCursos () {
		return new Promise((resolve, reject) => {
			axios.get(`${URL_MAPA}/cursos`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	alterarContratoDoOrcamento (contrato, orcamento) {
		return new Promise((resolve, reject) => {
			axios.patch(`${URL_MAPA}/alterar-contrato-orcamento`, {contrato: contrato, orcamento: orcamento}, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});
	}

	getUltimaSenhaCronograma () {
		return new Promise((resolve,reject)=>{
			axios.get(`${URL_MAPA}/cronograma/senha`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro)=>{
				reject(erro);
			});
		});	
	}

	consultarDadosPagamentoOrcamento (numero) {
		return new Promise((resolve,reject) => {
			axios.get(`${URL_MAPA}/orcamento/${numero}/info-pagamento`, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});	
	}

	atualizarPorcentagemComissao (data) {
		return new Promise((resolve,reject) => {
			axios.patch(`${URL_MAPA}/orcamento/desconto-comissao`, { idOrc: data.numero, descontoComissao: data.comissao }, {headers: {"Authorization": localStorage.getItem("tokenMapaVendas")}}).then((response)=>{
				resolve(response.data);
			}).catch((erro) => {
				reject(erro);
			});
		});	
	}

}


// WEBPACK FOOTER //
// ./src/services/mapa.js